import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { theme } from 'assets/styles/theme';
import FormStepWrapper from 'components/form/FormStepWrapper';
import { Text1, Text1Bold } from 'components/typography/Texts';
import Spinner from 'components/ui-elements/Spinner';
import { useBecomeFundraiser } from 'features/my-profile/become-fundraiser/context/BecomeFundraiserProvider';
import ContactSupportButton from 'features/my-profile/become-fundraiser/form/components/ContactSupportButton';

const DataSectionContainer = styled.div`
  white-space: pre-wrap;
`;

const Spacer = styled.div`
  height: 1px;
  width: 100%;
  border-top: 1px solid ${theme.color.darkGray};
  margin: 12px 0;
`;

const DataSection = ({ label, value, testId }: { label?: string; value?: string; testId?: string }) => {
  if (!label || !value) return <></>;
  return (
    <DataSectionContainer data-testid={testId}>
      <Text1Bold>{label}</Text1Bold>
      <Text1>{value}</Text1>
    </DataSectionContainer>
  );
};

const Summary = () => {
  const { t } = useTranslation('myProfile');
  const { formData, isFormValid, save, isSaving } = useBecomeFundraiser();

  const { addressLine1, addressLine2, city, state, zipCode, country } = formData.organization!;
  const organizationDetails = `${addressLine1} ${addressLine2 || ''}\n${city}, ${state} ${zipCode}\n${country}`;

  return (
    <FormStepWrapper
      header={t('become-fundraiser.summary.header')}
      description={t('become-fundraiser.summary.description')}
      isValid={isFormValid}
      onNextPress={save}>
      {isSaving && <Spinner />}
      {!isSaving && (
        <>
          <DataSection
            testId={'summary-organization'}
            label={formData.organization?.name}
            value={organizationDetails}
          />
          <Spacer />
          <DataSection
            testId={'summary-routing-number'}
            label={t('become-fundraiser.verify-routing-number.routing-number-placeholder')}
            value={formData.routingNumber}
          />
          <DataSection
            testId={'summary-account-number'}
            label={t('become-fundraiser.verify-account-number.account-number-placeholder')}
            value={formData.accountNumber}
          />
          <DataSection
            testId={'summary-mobile'}
            label={t('become-fundraiser.verify-contact-details.mobile-placeholder')}
            value={formData.mobilePhone}
          />
          <DataSection
            testId={'summary-email'}
            label={t('become-fundraiser.verify-contact-details.email-placeholder')}
            value={formData.email}
          />
          <ContactSupportButton />
        </>
      )}
    </FormStepWrapper>
  );
};

export default Summary;
